import React from 'react'

import css from './BurgerMenuIcon.styl'

export const BurgerMenuIcon = () => (
  <div className={css.BurgerMenuIcon}>
    <span />
  </div>
)
